import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Bounce, toast } from 'react-toastify';
import { getLast4Digits } from '../_services';
import { userService } from '../_services/user.service';

export const OtpSignUp = ({ handleComplete }) => {
  const navigate = useNavigate();
  const [loggingIn] = useState(false);
  const [showOtpInput, setShowOtpInput] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [phoneNumber, setPhoneNumber] = useState('');
  const [otp, setOtp] = useState('');
  const [timer, setTimer] = useState(120);
  const [error, setError] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name == 'phone') {
      if ((value + '').length > 10) {
        return;
      }
      setError('');

      setPhoneNumber(value);
    }
    if (name == 'otp') {
      setOtp(value);
    }
  };

  const handleClickGetOtp = () => {
    if (phoneNumber?.length == 10) {
      setIsLoading(true);
      setTimer(120);
      userService.getOtp(phoneNumber).then(
        (res) => {
          setIsLoading(false);
          if (res.error_code == 0) {
            setShowOtpInput(true);
          } else {
            if (res?.error_code == -1) {
              toast.error('Account Blocked!', {
                position: 'bottom-left',
                autoClose: 5000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: 'dark',
                transition: Bounce,
              });
            }
          }
        },
        () => {
          setIsLoading(false);
        },
      );
    } else {
      setError('Enter valid Phone Number');
    }
  };

  const handleSubmit = () => {
    if (otp.length == 6) {
      setIsLoading(true);
      userService.verifyOtp(phoneNumber, otp).then(
        (res) => {
          if (res.error_code == -1) {
            setIsLoading(false);
            toast.error(res.message.name ?? res.message, {
              position: 'bottom-left',
              autoClose: 5000,
              hideProgressBar: true,
              closeOnClick: true,
              pauseOnHover: true,
              draggable: true,
              progress: undefined,
              theme: 'dark',
              transition: Bounce,
            });
            return;
          }
          if (res.data.first_name && res.data.last_name && res.data.email) {
            setIsLoading(false);
            navigate('/');
          } else {
            setIsLoading(false);
            handleComplete({
              _id: res.data._id,
              first_name: res.data.first_name,
              last_name: res.data.last_name,
              email: res.data.email,
              education: res.data.education,
              college: res.data.college,
              phone: res.data.phone,
              address: res.data.address,
              profile_image: res.data.profile_image,
            });
          }
        },
        (err) => {
          setIsLoading(false);
          setError(err);
        },
      );
    } else {
      setError('Enter Valid Otp');
    }
  };

  useEffect(() => {
    let timerintervalid;
    // Update the timer every second
    if (timer > 0) {
      timerintervalid = setInterval(() => {
        setTimer((prevTimeout) => prevTimeout - 1);
      }, 1000);
    } else {
      // If the timer reaches 0, disable the button
      // setIsResendEnabled(false);
      clearInterval(timerintervalid);
    }
    // Clear the interval when the component is unmounted
    return () => clearInterval(timerintervalid);
  }, [timer]);

  const handleChangephoneNumber = () => {
    setShowOtpInput(false);
  };

  return (
    <div className='container pe-0 ps-0 mt-3'>
      {!showOtpInput && (
        <div className=''>
          <h1 className='phonehead'>Sign In</h1>
          <p className='phonedesc'>Enter your phone number.</p>
          <div className='phoneinput_container'>
            <div className='countrycode'>+91</div>
            <input
              type='number'
              name='phone'
              maxLength='10'
              max='9999999999'
              value={phoneNumber}
              placeholder='Your mobile number here'
              onChange={handleChange}
              autoComplete='new-password'
              className='phone_input'
            />
          </div>
          {error && (
            <div className='help-block error_message'>
              <img className='error_dot' src={'img/reddot.png'} />
              {error}
            </div>
          )}
          <button
            className='register_login_button'
            onClick={() => {
              handleClickGetOtp();
            }}
            disabled={!phoneNumber}
          >
            Get OTP
            {isLoading && <img src='/img/loader.gif' className='loadericon' />}
          </button>
        </div>
      )}
      {showOtpInput && (
        <div className=''>
          <h1 className='otphead'>Enter OTP</h1>
          <p className='phonedesc'>
            Enter OTP received on mobile number ending with XX{getLast4Digits(phoneNumber)}
          </p>

          <input
            type='number'
            name='otp'
            maxLength='10'
            max='9999999999'
            value={otp}
            placeholder=' -   -   -   -   -   -   '
            onChange={handleChange}
            autoComplete='new-password'
            className='otp_input'
          />
          <button
            className='register_login_button'
            onClick={() => {
              handleSubmit();
            }}
          >
            Login
            {loggingIn && <img src='/img/loader.gif' className='loadericon' />}
          </button>
          <div className='d-flex justify-content-between mt-1'>
            <div
              className='timer'
              onClick={() => {
                if (timer == 0) {
                  handleClickGetOtp();
                }
              }}
            >
              Resend code {timer > 0 && `in 00:${timer}`}
            </div>
            <p
              className='timer text-decoration-underline'
              onClick={() => {
                handleChangephoneNumber();
              }}
            >
              Wrong Number?
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
